module.exports = __webpack_public_path__ + "static/img/bg2.229137ba.jpg";